var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Top'),_c('div',{staticClass:"main"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('h6',[_vm._v(_vm._s(_vm.datetime))]),_c('p',[_vm._v(_vm._s(("" + _vm.Message)))])]),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }